import { StatusIndicator, type StatusIndicatorProps } from '@amzn/awsui-components-console';
import type { RuleStatus } from '@amzn/helianthus-arbiter-client';

interface RuleStatusIndicatorProps {
  status: RuleStatus | undefined;
}

const STATUS_MAP: Record<RuleStatus, { type: StatusIndicatorProps.Type; label: string }> = {
  active: { type: 'success', label: 'Active' },
  draft: { type: 'info', label: 'Draft' },
  dry_run: { type: 'pending', label: 'Dry Run' },
  provisioning: { type: 'in-progress', label: 'Provisioning' },
  inactive: { type: 'stopped', label: 'Inactive' },
  error: { type: 'error', label: 'Error' },
  deprecated: { type: 'warning', label: 'Deprecated' },
  deleted: { type: 'stopped', label: 'Deleted' },
};

/** Display label for a rule status; unknown values are returned unchanged. */
export function ruleStatusLabel(status: RuleStatus | undefined): string {
  return (status && STATUS_MAP[status]?.label) || status || 'Unknown';
}

export function RuleStatusIndicator({ status }: RuleStatusIndicatorProps) {
  const { type, label } = (status && STATUS_MAP[status]) || { type: 'info' as const, label: ruleStatusLabel(status) };
  return <StatusIndicator type={type}>{label}</StatusIndicator>;
}
